import { Box, Stack, Text } from '@chakra-ui/react'
import { withPage } from '@/features/layout'
import { FilterContextProvider } from '@/features/filters/context'
import AdminPageViewFilterSection from '../../components/AdminPageViewFilterSection/AdminPageViewFilterSection'
import AdminPageViewTable from '../../components/AdminPageViewTable/AdminPageViewTable'

function AdminPageViewPage() {
  return (
    <FilterContextProvider>
      <Box layerStyle="container" p={8}>
          <Stack spacing="24px">
            <Box>
              <Text as="h1" textStyle="h1">Page View Export</Text>
              <Text color="gray.500">Export page view data for any company.</Text>
            </Box>
            <AdminPageViewFilterSection />
            <AdminPageViewTable />
          </Stack>
      </Box>
    </FilterContextProvider>
  )
}

export default withPage(AdminPageViewPage)
